<template>
  <HelloWorld
    hide-mini-program-qr
    android-apk-config-key="xsjd_apk_url"
    ios-app-url="https://apps.apple.com/cn/app/id6755748482"
    custom-download-qr
    :download-qr-code-src="downloadQrCodeSrc"
    :auto-download="autoDownload"
  />
</template>

<script>
import QRCode from 'qrcode'
import HelloWorld from './HelloWorld.vue'

export default {
  name: 'XsjdPage',
  components: {
    HelloWorld
  },
  data() {
    return {
      autoDownload: new URLSearchParams(window.location.search).get('download') === '1',
      downloadQrCodeSrc: ''
    }
  },
  mounted() {
    const downloadOrigin = process.env.VUE_APP_XSJD_DOWNLOAD_ORIGIN || window.location.origin
    const downloadUrl = new URL('/xsjd-download.html', downloadOrigin).toString()

    QRCode.toDataURL(downloadUrl, {
      width: 400,
      margin: 1,
      errorCorrectionLevel: 'M'
    }).then((dataUrl) => {
      this.downloadQrCodeSrc = dataUrl
    })
  }
}
</script>
